import React from 'react';
import getIsBusinessEmail from '$lib/getIsBusinessEmail';
import getIsFinanceExam from '$lib/getIsFinanceExam';
import IndividualReferral from './IndividualReferral';
import FinanceFirmReferral from './FinanceFirmReferral';

const getReferralComponent = ({ currentUser, product }) => {
  const { email, organizationUuid } = currentUser;
  const { slug: productSlug } = product;

  const isBusinessEmail = getIsBusinessEmail({ email });
  const isFinanceExam = getIsFinanceExam({ productSlug });

  if (!organizationUuid && isFinanceExam && isBusinessEmail) {
    return FinanceFirmReferral;
  }

  return IndividualReferral;
};

const MiniRefer = (props) => {
  const { currentUser, product } = props;
  const ReferralComponent = getReferralComponent({ currentUser, product });

  return <ReferralComponent currentUser={currentUser} product={product} />;
};

export default MiniRefer;
